export default {
	baseUrl: 'http://localhost:8080/springboot3gqhf8g4/',
	name: '/springboot3gqhf8g4',
	indexNav: [
		{
			name: '猪舍信息',
			url: '/index/zhushexinxi',
		},
		{
			name: '防疫计划',
			url: '/index/fangyijihua',
		},
		{
			name: '疫苗信息',
			url: '/index/yimiaoxinxi',
		},
		{
			name: '公告信息',
			url: '/index/news'
		},
	],
	cateList: [
	]
}
